import { render, staticRenderFns } from "./GlobalRides.vue?vue&type=template&id=75fc5e23&scoped=true"
import script from "./GlobalRides.vue?vue&type=script&lang=js"
export * from "./GlobalRides.vue?vue&type=script&lang=js"
import style0 from "./GlobalRides.vue?vue&type=style&index=0&id=75fc5e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fc5e23",
  null
  
)

export default component.exports